import React from 'react';
import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../core/models/RouteHelper';
import MatchReport from './MatchReport';
import ValidationWindow from '../match-log/ValidationWindow';

interface OwnProps {
    userProfile?: Profile;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

// Route navigation must dispose the previous Match's socket, draft and preference.
const MatchReportRoute = (props: Props): React.ReactElement =>
    React.createElement(ValidationWindow, { matchId: Number(props.match.params.matchId), key: props.match.params.matchId,
        children: React.createElement(MatchReport, { ...props, key: props.match.params.matchId }) });

export default withRouter(MatchReportRoute);
